import React from 'react'
import carousalImage from './Images/carousalThree.jpg'
import { Link } from 'react-router-dom'
export default function CarousalTwo() {
    return (
        <div id="carouselExampleCaptions" class="carousel slide" data-bs-ride="false">

            <div class="carousel-inner parallax">
                <div class="carousel-item active">
                    <div className="p-3">
                        <div data-aos="fade-up" data-aos-duration="2000">
                            <div className="mt-5">
                                <div className="mt-5">
                                    <div className="mt-5 pt-2">
                                        <div className="changer">
                                            <div className="changer twoOne">
                                                <h4 style={{ fontSize: '3vh' }}>WORKING WITH US</h4>
                                                <h1 className='' style={{ fontSize: '5vh', fontWeight: 'bold' }}>CONTRACTORS & CONSTRUCTION <br />
                                                    MANAGERS SINCE 1989</h1>
                                                <Link to="/"> <button style={{ borderRadius: "0px", border: "2px solid white", color: 'white' }} className="btn p-2">GET A QUOTE</button></Link>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="carousel-caption d-md-block">




                    </div>
                </div>

            </div>

        </div>
    )
}


// WEBPACK FOOTER //
// ./src/components/carousal copy.jsx